import { WorldPosition } from 'types'

export enum ReferencePlaneAlias {
  TRANSVERSE = 'Transverse',
  LONGITUDINAL = 'Longitudinal',
  VERTICAL = 'Vertical',
}

export enum ReferencePlaneColor {
  WHITE = 'white',
  BLUE = 'blue',
}

export type KVReferencePlaneJSON = {
  referencePlaneId: string
  referencePlaneOrigin?: WorldPosition
  referencePlaneNormal?: WorldPosition
  referencePlaneVertices?: WorldPosition[]
  referencePlaneLabel?: string
  referencePlaneColor?: ReferencePlaneColor
  isFrame?: boolean
  frameNumber?: number
  visible?: boolean
  showInAnnotation?: boolean
  annotationAlias?: ReferencePlaneAlias | ''
  userName?: string
  userEmail?: string
  createdAt?: string
}

export class KVReferencePlane {
  id: string
  origin?: WorldPosition
  normal?: WorldPosition
  vertices?: WorldPosition[]
  label: string
  color?: ReferencePlaneColor
  isFrame: boolean
  frameNumber?: number
  visible: boolean
  showInAnnotation: boolean
  annotationAlias: ReferencePlaneAlias | ''
  userName: string
  userEmail: string
  createdAt: string

  constructor(id: string) {
    this.id = id
    this.origin = undefined
    this.normal = undefined
    this.vertices = undefined
    this.label = 'Reference Plane'
    this.color = undefined
    this.isFrame = false
    this.frameNumber = undefined
    this.visible = true
    this.showInAnnotation = false
    this.annotationAlias = ''
    this.userName = ''
    this.userEmail = ''
    this.createdAt = new Date().toISOString()
  }

  static fromJSON(json: KVReferencePlaneJSON): KVReferencePlane {
    const referencePlane = new KVReferencePlane(json.referencePlaneId)
    if (json.referencePlaneOrigin) {
      referencePlane.origin = json.referencePlaneOrigin
    }
    if (json.referencePlaneNormal) {
      referencePlane.normal = json.referencePlaneNormal
    }
    if (json.referencePlaneVertices) {
      referencePlane.vertices = json.referencePlaneVertices
    }
    referencePlane.label = json.referencePlaneLabel || 'Reference Plane'
    referencePlane.color = json.referencePlaneColor
    referencePlane.isFrame = json.isFrame ?? false
    referencePlane.frameNumber = json.frameNumber
    referencePlane.visible = json.visible ?? true
    referencePlane.showInAnnotation = json.showInAnnotation ?? false
    referencePlane.annotationAlias = json.annotationAlias ?? ''
    referencePlane.userName = json.userName ?? ''
    referencePlane.userEmail = json.userEmail ?? ''
    referencePlane.createdAt = json.createdAt ?? new Date().toISOString()
    return referencePlane
  }

  static toJSON(referencePlane: KVReferencePlane): KVReferencePlaneJSON {
    const json: KVReferencePlaneJSON = {
      referencePlaneId: referencePlane.id,
      referencePlaneOrigin: referencePlane.origin,
      referencePlaneNormal: referencePlane.normal,
      referencePlaneVertices: referencePlane.vertices,
      referencePlaneLabel: referencePlane.label,
      visible: referencePlane.visible,
      showInAnnotation: referencePlane.showInAnnotation,
      annotationAlias: referencePlane.annotationAlias,
      userName: referencePlane.userName,
      userEmail: referencePlane.userEmail,
      createdAt: referencePlane.createdAt,
    }
    if (referencePlane.color) {
      json.referencePlaneColor = referencePlane.color
    }
    if (referencePlane.isFrame) {
      json.isFrame = true
      json.frameNumber = referencePlane.frameNumber
    }
    return json
  }
}
